"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));
var _countryNames = _interopRequireDefault(require("./countryNames"));
var _Select2 = _interopRequireDefault(require("./Select.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Select = _ref => {
  let {
    className = "",
    countryList,
    error = false,
    errorMessage,
    label,
    lang = "de",
    name,
    required,
    setValue,
    subItems = [],
    value = "",
    FormControlProps,
    InputLabelProps,
    SelectProps
  } = _ref;
  const css = (0, _Select2.default)();
  const [localValue, setLocalValue] = (0, _react.useState)("");
  const [options, setOptions] = (0, _react.useState)([]);
  const fieldLabel = required ? label + " *" : label;
  const isControlledField = setValue ? true : false;
  (0, _react.useEffect)(() => {
    if (subItems.length === 0 && countryList) {
      const countries = (0, _countryNames.default)(lang);
      const countriesAsList = [];
      let counter = 0;
      for (const countryShort in countries) {
        if (countries.hasOwnProperty(countryShort)) {
          countriesAsList.push({
            "attr-value": countryShort,
            id: counter,
            text: countries[countryShort]
          });
          counter++;
        }
      }
      setOptions(countriesAsList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(subItems)]);
  (0, _react.useEffect)(() => {
    if (!countryList) {
      setOptions(subItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryList, JSON.stringify(subItems)]);
  (0, _react.useEffect)(() => {
    setLocalValue(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.select, "mco-form-select", className)
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
    variant: "outlined",
    "data-required": required,
    error: error
  }, FormControlProps), /*#__PURE__*/_react.default.createElement(_InputLabel.default, InputLabelProps, /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: fieldLabel
    }
  })), /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    label: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: fieldLabel
      }
    }),
    name: name,
    onChange: e => {
      if (isControlledField) {
        setValue(e.target.value);
      } else {
        setLocalValue(e.target.value);
      }
    },
    value: localValue,
    MenuProps: {
      classes: {
        paper: css.menuPaper
      }
    }
  }, SelectProps), options?.map((option, counter) => {
    const {
      "attr-value": attrValue,
      disabled = false,
      text
    } = option;
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      disabled: disabled,
      key: counter,
      value: attrValue
    }, text);
  })), error && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, errorMessage)));
};
var _default = exports.default = Select;